import { NON_ADMIN_GROUP_NAME_SUBSTRING } from '../constants';
import { GroupApiResponse } from '../types';
import { UserRole } from '@modules/core/types';

export const getNonAdminGroup = (groups: GroupApiResponse[]): GroupApiResponse | undefined => {
  return groups?.find((g) => g.profile.name.includes(NON_ADMIN_GROUP_NAME_SUBSTRING));
};

export const isNonAdminRole = (roleName: string): boolean => {
  return UserRole.ADMINISTRATOR.toLowerCase() !== roleName.toLowerCase();
};
